// Checks if local storage or session storage is available in a safe manner.
// Copied from: https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API#Feature-detecting_localStorage
function storageAvailable(type: 'localStorage' | 'sessionStorage'): boolean {
   let storage;
   try {
      storage = window[type];
      const x = '__storage_test__';
      storage.setItem(x, x);
      storage.removeItem(x);
      return true;
   } catch (e) {
      // @ts-expect-error TS(2322) FIXME: Type 'boolean | undefined' is not assignable to ty... Remove this comment to see the full error message
      return (
         e instanceof DOMException &&
         // everything except Firefox
         (e.code === 22 ||
            // Firefox
            e.code === 1014 ||
            // test name field too, because code might not be present
            // everything except Firefox
            e.name === 'QuotaExceededError' ||
            // Firefox
            e.name === 'NS_ERROR_DOM_QUOTA_REACHED') &&
         // acknowledge QuotaExceededError only if there's something already stored
         storage &&
         storage.length !== 0
      );
   }
}

export function sessionStorageAvailable(): boolean {
   return storageAvailable('sessionStorage');
}

export function localStorageAvailable(): boolean {
   return storageAvailable('localStorage');
}
